import { Field, useField } from 'formik'
import FieldError from '../FieldError/FieldError'

const Checkbox = ({ children, ...props }) => {
  const { name } = props
  const [field] = useField({ name, type: 'checkbox' })
  return (
    <div style={{ position: 'relative' }}>
      <label htmlFor={name}>
        <Field type="checkbox" {...field} {...props} />
        {children}
      </label>
      <FieldError name={name} />
    </div>
  )
}

export default Checkbox
